import React, { useEffect, useState } from "react";
import "./TerminalWidget.css";

const TERMINAL_MESSAGES = [
  "Cảnh báo: Sảnh LLWIN đang có biến động mạnh!",
  "Cảnh báo: Sảnh FLY88 tỷ lệ nổ hũ tăng đột biến!",
  "Hệ thống: Đang đồng bộ dữ liệu thuật toán sảnh LLWIN...",
  "Cảnh báo: Sảnh XX88 đang ghi nhận lượng truy cập cao!",
  "Thông báo: Khởi tạo API kết nối sảnh Baccarat thành công!",
  "Cảnh báo: Tải máy chủ khu vực Châu Á đạt 82%!",
  "Hệ thống: Đã cập nhật ma trận dự đoán thuật toán phiên mới!",
  "Cảnh báo: Tín hiệu đường truyền sảnh LLWIN ổn định 100%!",
];

const TerminalWidget: React.FC = () => {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % TERMINAL_MESSAGES.length);
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="terminal-corner-widget" aria-label="Hộp thông báo Terminal">
      <header className="terminal-corner-widget__head">
        <span className="terminal-corner-widget__title">Terminal</span>
        <span className="terminal-corner-widget__dot" aria-hidden />
      </header>
      <div className="terminal-corner-widget__divider" />
      <div className="terminal-corner-widget__body">
        <p className="terminal-corner-widget__text">
          {TERMINAL_MESSAGES[msgIndex]}
        </p>
      </div>
    </div>
  );
};

export default TerminalWidget;
